"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  link: {
    textDecoration: 'none'
  },
  linkInner: {
    fontWeight: 'normal',
    textDecoration: 'none'
  }
};

// TODO: добавить utm метки, когда будет готова задача
// https://leveltravel.atlassian.net/browse/LT-10205
var Link = function Link(_ref) {
  var href = _ref.href,
    children = _ref.children,
    style = _ref.style,
    innerStyle = _ref.innerStyle;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    style: _objectSpread(_objectSpread({}, styles.link), style),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    style: _objectSpread(_objectSpread({}, styles.linkInner), innerStyle)
  }, children));
};
Link.defaultProps = {
  style: {},
  innerStyle: {}
};
Link.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  style: _propTypes["default"].shape({}),
  innerStyle: _propTypes["default"].shape({})
};
var _default = exports["default"] = Link;